import _ from 'lodash';

export const getNameInitials = (name: string) => {
    const words = _.words(name);
    if (!words || words.length === 0) return '';

    const first = words[0]?.[0]?.toUpperCase() ?? '';
    const last = words.length > 1 ? words[words.length - 1]?.[0]?.toUpperCase() ?? '' : '';

    return first + last;
};
